import { MortgageApplicationStore } from '@lower-financial/mortgage-utils';

export const checkIfBorrowersShareAddress = (mortgageApplication: MortgageApplicationStore) => (
  mortgageApplication.borrowerCity === mortgageApplication.coBorrowerCity
  && mortgageApplication.borrowerState === mortgageApplication.coBorrowerState
  && mortgageApplication.borrowerZipCode === mortgageApplication.coBorrowerZipCode
  && mortgageApplication.borrowerStreetAddress === mortgageApplication.coBorrowerStreetAddress
  && mortgageApplication.borrowerCounty === mortgageApplication.coBorrowerCounty
);
